import { Currency, ETHER, Token } from '@pancakeswap/sdk'
import { BinanceIcon } from '@pancakeswap/uikit'
import { useMemo } from 'react'
import styled from 'styled-components'
import { WrappedTokenInfo } from 'state/types'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import useHttpLocations from '../../hooks/useHttpLocations'
import getTokenLogoURL from '../../utils/getTokenLogoURL'
import Logo from './Logo'

import { isRobinhoodChain } from 'config/constants/chains'
const StyledLogo = styled(Logo)<{ size: string }>`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border-radius: 50%;
`

function EthereumIcon({
  size,
  style,
}: {
  size: string
  style?: React.CSSProperties
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 417"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      aria-label="Ethereum logo"
    >
      <path fill="#343434" d="M127.9 0 125.1 9.5v269.1l2.8 2.8 127.9-75.6z" />
      <path fill="#8C8C8C" d="M127.9 0 0 205.8l127.9 75.6V154.1z" />
      <path fill="#3C3C3B" d="m127.9 305.7-1.6 1.9v98.1l1.6 4.7L255.9 230z" />
      <path fill="#8C8C8C" d="M127.9 410.4V305.7L0 230z" />
      <path fill="#141414" d="m127.9 281.4 127.9-75.6-127.9-51.7z" />
      <path fill="#393939" d="m0 205.8 127.9 75.6V154.1z" />
    </svg>
  )
}

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
}) {
  const { chainId } = useActiveWeb3React()
  const uriLocations = useHttpLocations(currency instanceof WrappedTokenInfo ? currency.logoURI : undefined)

  const srcs: string[] = useMemo(() => {
    if (currency === ETHER) return []

    if (currency instanceof Token) {
      if (currency instanceof WrappedTokenInfo) {
        return [...uriLocations, getTokenLogoURL(currency.address)]
      }
      return [getTokenLogoURL(currency.address)]
    }
    return []
  }, [currency, uriLocations])

  if (currency === ETHER) {
    if (isRobinhoodChain(chainId)) {
      return <EthereumIcon size={size} style={style} />
    }

    return <BinanceIcon width={size} style={style} />
  }

  return <StyledLogo size={size} srcs={srcs} alt={`${currency?.symbol ?? 'token'} logo`} style={style} />
}
